export const DEFAULT_PRODUCTS = [
  { value: 'product1', label: 'Рамка А4' },
  { value: 'product2', label: 'Электронка' },
  { value: 'product3', label: 'Без рамки/БР' },
];

export const DEFAULT_CONSUMABLES = [
  { value: 'frames_a4', label: 'Рамки A4' },
  { value: 'frames_10x15', label: 'Рамки 10x15' },
  { value: 'packages', label: 'Пакеты' },
  { value: 'envelopes', label: 'Конверты' },
  { value: 'photo_paper', label: 'Фотобумага (листы)' },
  { value: 'ink', label: 'Краска' },
];

const TEST_PRODUCT_RE = /^(новый продукт \d+|тест продукт)/i;

export function parseReferenceJson(raw) {
  if (raw === null || raw === undefined || raw === '') return null;
  try {
    return typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch {
    return null;
  }
}

export function sanitizeProductsList(list) {
  if (!Array.isArray(list) || !list.length) return [...DEFAULT_PRODUCTS];
  const cleaned = list.filter((item) => {
    const label = String(item?.label || '').trim();
    return label && !TEST_PRODUCT_RE.test(label);
  });
  return cleaned.length ? cleaned : [...DEFAULT_PRODUCTS];
}

export function mergeConsumablesList(list) {
  const stored = Array.isArray(list) ? list : [];
  const byValue = new Map();
  stored.forEach((item) => {
    if (item?.value) byValue.set(item.value, item);
  });
  DEFAULT_CONSUMABLES.forEach((item) => {
    if (!byValue.has(item.value)) byValue.set(item.value, item);
  });
  return [...byValue.values()];
}

export function sanitizeReferencePayload(state = {}) {
  const clean = { ...state };
  const products = parseReferenceJson(clean.products);
  if (products) {
    clean.products = JSON.stringify(sanitizeProductsList(products));
  }
  const consumables = parseReferenceJson(clean.consumablesItems);
  if (consumables) {
    clean.consumablesItems = JSON.stringify(mergeConsumablesList(consumables));
  }
  return clean;
}
